import setupImages from '../offer/setup-images';
import createOfferDescription from './description';
import createOfferDetails from './details';
import createOfferIntro from './intro';
import createOfferOrganization from './organization';

function scrollTop() {
  if (document.querySelectorAll('.error.active').length === 0) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}

function shouldScrollTop() {
  if (document.querySelector('.create-offer') !== null) {
    scrollTop();
  }
}

export const initCreateOffer = () => {
  if (!document.querySelector('.create-offer')) {
    return;
  }

  shouldScrollTop();

  // init step Intro
  if (document.querySelector('.create-offer--step-intro') !== null) {
    createOfferIntro();
  }

  // init step Description
  if (document.querySelector('.create-offer--step-description') !== null) {
    createOfferDescription('.create-offer--step-description');
  }

  // init step Details
  if (document.querySelector('.create-offer--step-details') !== null) {
    createOfferDetails('.create-offer--step-details');
  }

  // init step Organization
  if (document.querySelector('.create-offer--step-organization') !== null) {
    createOfferOrganization('.create-offer--step-organization');
  }

  // init step Images
  if (document.querySelector('.create-offer--step-images') !== null) {
    setupImages();
  }
};
